<template>
    <div class="form-item">
        <div class="form-label">
            <label v-if="label != null">{{ label }}</label>
        </div>
        <div class="form-value" style="width: 600px;">
            <label><input :disabled="disabled" type="checkbox" v-model="useFrom" @change="syncModel"/> 从</label>
            <el-time-picker :type="dateType" style="width:90px;" :disabled="disabled || !useFrom" v-model="curValue.from" align="center" :format="format" :value-format="format" :clearable="false" @change="syncModel"></el-time-picker>
            <label><input :disabled="disabled" type="checkbox" v-model="useTo" @change="syncModel"/> 至</label>
            <el-time-picker :type="dateType" style="width:90px;" :disabled="disabled || !useTo" v-model="curValue.to" align="center" :format="format" :value-format="format" :clearable="false" @change="syncModel"></el-time-picker>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    //有效的值类型
    let validValueTypes = ['String', 'Date'];

    function isValidValueType(valueType) {
        return validValueTypes.indexOf(valueType) != -1;
    }

    //时间/时间字符串转为Date对象
    function toDateInst(timeOrStr) {
        if(typeof timeOrStr == 'string') {
            timeOrStr = timeOrStr.trim();
            if(timeOrStr.length == 0) {
                return null;
            }
            if(timeOrStr.indexOf(' ') == -1 && timeOrStr.indexOf(':') != -1) {
                //纯时间，不包含日期（加上日期部分）
                let todayStr = new Date().format('yyyy-MM-dd');
                timeOrStr = todayStr + ' ' + timeOrStr;
            }
        }
        return Date.parseAsDate(timeOrStr);
    }

    function getModelResultValue(curValue, valueType, format) {
        let resultValue = curValue;
        if(resultValue != null) {
            resultValue = toDateInst(resultValue);
            //
            if(valueType == 'String' && Utils.isDate(resultValue)) {
                resultValue = resultValue.format(format);
            }
        }
        return resultValue;
    }

    //
    export default {
        name: 'swb-query-time2-field',
        //
        props: {
            valueType: {
                type: String,
                default: 'String'
            },
            label: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            iniValue: {
                default: null
            }
        },
        //
        data() {
            return {
                format: 'HH:mm',
                //
                useFrom: false,
                useTo: true,
                //
                curValue: {
                    from: null,
                    to: null
                }
            };
        },
        watch: {
            valueType(newVal, oldVal) {
                this.init();
            },
            iniValue(newVal, oldVal) {
                this.init();
            }
        },
        //
        created() {
            this.init();
        },
        //
        methods: {
            init() {
                if(!isValidValueType(this.valueType)) {
                    let message = '组件的值类型有误，可用的值类型为：' + validValueTypes.join(", ");
                    if(typeof Toast !== 'undefined') {
                        Toast.show(message, 3000, 'error');
                    }
                    else {
                        MsgBox.error(message);
                    }
                }
                //
                this.curValue = {
                    from: '09:00',
                    to: '17:00'
                };
                //
                let iniValue = this.iniValue || {};
                this.useFrom = iniValue.from != null;
                this.useTo = iniValue.to != null;
                //初始化
                if(typeof iniValue.from != 'undefined') {
                    iniValue.from = typeof iniValue.from == 'string' ? toDateInst(iniValue.from) : iniValue.from;
                }
                if(typeof iniValue.to != 'undefined') {
                    iniValue.to = typeof iniValue.to == 'string' ? toDateInst(iniValue.to) : iniValue.to;
                }
                this.curValue = Utils.merge(this.curValue, iniValue);
                this.syncModel();
            },
            syncModel() {
                let resultValue = {};
                if(this.useFrom) {
                    resultValue.from = getModelResultValue(this.curValue.from, this.valueType, this.format);
                }
                if(this.useTo) {
                    resultValue.to = getModelResultValue(this.curValue.to, this.valueType, this.format);
                }
                //
                this.$emit('input', resultValue);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/query/QueryTime2Field.vue